import React from 'react';
import classNames from 'classnames';
import GridWrapper from './GridWrapper';
import VerticalGridBody from './VerticalGridBody';

export default function VerticalGrid(props) {
  const { className } = props;
  return (
    <GridWrapper {...props} className={classNames(className, 'vertical-grid')}>
      <VerticalGridBody {...props} />
    </GridWrapper>
  );
}
